import { type ReactNode } from 'react';
import { GlowOrb } from '@/components/effects/glow-orb';
import { useSignupPage } from '../hooks/use-signup-page';
import { useRequireStep } from '../hooks/use-require-registration-step';
import { SignupFormContent } from './signup-form-content';

export function SignupFormPage(): ReactNode {
  useRequireStep('signup');
  const s = useSignupPage();

  return (
    <div className="relative flex min-h-dvh items-center justify-center bg-void px-md py-lg sm:px-base sm:py-xl">
      <GlowOrb />
      <div className="relative z-10 w-full max-w-[420px] space-y-md">
        <SignupFormContent {...s} />
      </div>
    </div>
  );
}
